var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('grid-filters',{attrs:{"grid-data":"theGrid","fields":_vm.gridFilters}}),_c('Grid',{ref:"theGrid",attrs:{"name":"bestofResultsGrid","url":_vm.url,"preload":_vm.preload,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }